import { Link } from "react-router-dom";
import { TagCard } from "./TagCard";
import type { useInventoryList } from "../lib/useInventoryList";

/** The searchable, infinitely scrolling on-hand list under Inventory and Explorer. */
export function InventoryList({
  list, title, q, onSearch, filtering, onClear,
}: {
  list: ReturnType<typeof useInventoryList>;
  title: string;
  q: string;
  onSearch: (q: string) => void;
  filtering: boolean;
  onClear: () => void;
}) {
  const { items, total, loading, loadingMore, hasMore, loadMore, sentinel } = list;
  return (
    <section className="rail">
      <div className="list-head">
        <h2 className="eyebrow rail-label" style={{ margin: 0 }}>{title}</h2>
        {filtering && <button className="quiet" onClick={onClear}>Clear filters</button>}
      </div>

      <input
        className="search"
        type="search"
        placeholder="Search title, brand, SKU, size, store…"
        value={q}
        onChange={(e) => onSearch(e.target.value)}
      />

      {loading && items.length === 0 ? (
        <p className="hint">Loading…</p>
      ) : items.length === 0 ? (
        <div className="empty">
          <p>{filtering ? "No items match this filter." : "Nothing on hand yet."}</p>
          {filtering
            ? <button className="ghost" onClick={onClear}>Clear filters</button>
            : <Link to="/intake"><button className="ghost">Add a find</button></Link>}
        </div>
      ) : (
        <>
          {items.map((item) => <TagCard key={item.id} item={item} />)}
          <div ref={sentinel} />
          {hasMore && (
            <div className="list-more">
              <button className="ghost" onClick={() => void loadMore()} disabled={loadingMore}>
                {loadingMore ? "Loading…" : `Show more (${items.length} of ${total})`}
              </button>
            </div>
          )}
        </>
      )}
    </section>
  );
}
